import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhQueryAutoWeb, VhImage, VhEventMediator } from 'vhautowebdb';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';

@Component({
  selector: 'atw-frame-news-group-config',
  templateUrl: './frame-news-group-config.component.html',
  styleUrls: ['./frame-news-group-config.component.scss']
})
export class AtwFrameNewsGroupConfig implements OnInit {
  // lấy giá trị data trả vể từ page
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() position: any; // là dữ liệu position từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database

  @Output() changeOptionConfig = new EventEmitter<any>();
  public isViewAll: boolean = false;
  public isCollapsed: boolean = false;
  public currentViewAll: any = {};
  // Xử lý chỉ mở được 1 menu 1 lần
  public openMenu: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
  };
  public urlBackgroundImage = ''; // Hình ảnh nền của frame (nếu có)
  public gapSpace = 0;
  public loadComplete = false;
  public stylesField = [
    {
      title: 'Điều chỉnh viền khung',
      index: 1,
    },
    {
      title: 'Điều chỉnh viền phần tử',
      index: 2,
    },
  ];
  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhImage: VhImage,
    private matdialog: MatDialog,
    private vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId))
      if (this.class && this.config) {
        this.loadComplete = true;
        // Khoảng cách giữa cột và dòng
        this.gapSpace = parseInt(
          this.class['frame-news-group__products']['gap'],
          10
        );
      }
  }

  openHandler(value: string): void {
    for (const key in this.openMenu) {
      if (key !== value) {
        this.openMenu[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /** Hàm thực hiện kiểm tra điều kiện 1 hướng của viền và active option đấy nếu đủ điều kiện
   *
   * @param value
   */
  checkActiveDirectionBorder(value: any) {
    if (['0px', '0'].includes(value)) return false;
    return true;
  }



  /** Hàm thực hiện cập nhật liên quan khi thay đổi số lượng cột
   *
   * @param event
   */
  handleChangeCols(event: any) {
    this.config['frame-news-group__products']['cols'] = event;
    // cập nhật trường grid-template-columns
    this.config['frame-news-group__products']['total_products'] =
      this.config['frame-news-group__products']['cols'] *
      this.config['frame-news-group__products']['rows'];
    this.updateClass();
    this.updateConfig();
  }

  /** Hàm thực hiện cập nhật liên quan khi thay đổi số lượng dofng
   *
   * @param event
   */
  handleChangeRows(event: any) {
    this.config['frame-news-group__products']['rows'] = event;
    // cập nhật trường grid-template-rows

    this.class['frame-news-group__products']['grid-template-rows'] = `repeat(${this.config['frame-news-group__products'].rows
      },${this.calcSpaceGrid(this.config['frame-news-group__products'].rows)})`;
    this.config['frame-news-group__products']['total_products'] =
      this.config['frame-news-group__products']['cols'] *
      this.config['frame-news-group__products']['rows'];

    this.updateClass();
    this.updateConfig();
  }
  /** Hàm này trả về một chuỗi để chia layout cho grid
   * @param cols
   * @param gap
   *
   * @example
   * cols = 4
   * gap = 12
   * Kết quả: calc(25% - 9px)
   * @return calc(${100/cols}% - ${(gap/cols)*(cols-1)}px)
   *
   */
  calcSpaceGrid(cols) {
    let gap = parseInt(this.class['frame-news-group__products'].gap, 10);
    return `calc(${100 / cols}% - ${(gap / cols) * (cols - 1)}px)`;
  }

  /** Hàm thực hiện cập nhật khoảng cách gỡ các dòng cột, xử lý chia cột dòng
   *
   * @param event
   */
  handleChangeGap(event: any) {
    this.class['frame-news-group__products']['gap'] = `${event}px`;
    this.class['frame-news-group__products']['grid-template-columns'] = `repeat(${this.config['frame-news-group__products']['cols']
      },${this.calcSpaceGrid(this.config['frame-news-group__products'].cols)})`;
    // cập nhật trường grid-template-rows
    this.class['frame-news-group__products']['grid-template-rows'] = `repeat(${this.config['frame-news-group__products'].rows
      },${this.calcSpaceGrid(this.config['frame-news-group__products'].rows)})`;
    // Cập nhật tường grid-auto-columns
    this.class['frame-news-group__products'][
      'grid-auto-columns'
    ] = `${this.calcSpaceGrid(this.config['frame-news-group__products'].cols)}`;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý font-size icon left
   *
   * @param event
   */
  handleFontSizeIconLeft(event) {
    let value = `${event}px`;
    this.class['frame-news-group__left-arrow--icon']['font-size'] =
      this.class['frame-news-group__left-arrow--icon']['height'] =
      this.class['frame-news-group__left-arrow--icon']['width'] =
      value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý font-size icon right
   *
   * @param event
   */
  handleFontSizeIconRight(event) {
    let value = `${event}px`;
    this.class['frame-news-group__right-arrow--icon']['font-size'] =
      this.class['frame-news-group__right-arrow--icon']['height'] =
      this.class['frame-news-group__right-arrow--icon']['width'] =
      value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý icon trái cách bên trái
   *
   * @param event
   */
  handleLeftArrowLeft(event) {
    let value = `${event}%`;
    this.class['frame-news-group__left-arrow']['left'] = value;
    this.updateClass();
  }
  /** Hàm thực hiện xử lý icon phải cách bên phải
   *
   * @param event
   */
  handleRightArrowRight(event) {
    let value = `${event}%`;
    this.class['frame-news-group__right-arrow']['right'] = value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý icon trái cách bên trên
   *
   * @param event
   */
  handleTopArrowLeft(event) {
    let value = `${event}%`;
    this.class['frame-news-group__left-arrow']['top'] = value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý icon phải cách bên trên
   *
   * @param event
   */
  handleTopArrowRight(event) {
    let value = `${event}%`;
    this.class['frame-news-group__right-arrow']['top'] = value;
    this.updateClass();
  }

  //Hàm update class
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {

      });
  }

  //Hàm update class
  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {

      });
  }



  //Hàm update position
  updatePosition() {
    this.vhQueryAutoWeb
      .updateBlock(this.objectChoosing._id, {
        [this.device + 'position']: this.position,
      })
      .then((bool: any) => {

      });
  }
}
